import React, { FC } from 'react';
import { Box, Text, Stepper, Step } from '@bechtel/gds';
import { MWRHistoryContentStyled } from './styled';
import { CommodityProgressStepBarProps } from '../types';
import { find, orderBy } from 'lodash';
import { MwrStatus } from '@bechtel/types';
import { useDate } from '@bechtel/client-common';
import { t, Trans } from '@lingui/macro';

const getHistoryItems = (mwrStatus: MwrStatus, mwrDate: string): Step[] => {
  const items: Step[] = [
    {
      label: <Trans>MWR Received</Trans>,
      isCompleted: !!mwrStatus,
      subLabel: `${mwrStatus == MwrStatus.ISSUED ? `(${mwrDate})` : ``}`,
    },
    {
      label: <Trans>Crew Assigned</Trans>,
      isCompleted:
        mwrStatus == MwrStatus.CREW_ASSIGNED || mwrStatus == MwrStatus.IN_PICKING || mwrStatus == MwrStatus.LOADED,
      subLabel: `${mwrStatus == MwrStatus.CREW_ASSIGNED ? `(${mwrDate})` : ``}`,
    },
    {
      label: <Trans>In Picking</Trans>,
      isCompleted: mwrStatus == MwrStatus.IN_PICKING || mwrStatus == MwrStatus.LOADED,
      subLabel: `${mwrStatus == MwrStatus.IN_PICKING ? `(${mwrDate})` : ``}`,
    },
    {
      label: <Trans>Issued</Trans>,
      isCompleted: mwrStatus == MwrStatus.LOADED,
      subLabel: `${mwrStatus == MwrStatus.LOADED ? `(${mwrDate})` : ``}`,
    },
  ];
  return items;
};

export const MWRHistoryPopperContent: FC<CommodityProgressStepBarProps> = ({ material }) => {
  const { formatISODate } = useDate();
  if (!material || !material.mwrs || material.mwrs.length == 0) return null;
  let sourceMWR = find(material.mwrs, (mwr) => mwr.mwrStatus == MwrStatus.LOADED);
  if (!sourceMWR) sourceMWR = orderBy(material.mwrs, 'mwrNumber', 'desc')[0];
  if (!sourceMWR) return null;
  const items = getHistoryItems(sourceMWR.mwrStatus, formatISODate(sourceMWR.mwrDate));

  return (
    <Box style={{ width: '168px', userSelect: 'none' }} flexDirection={{ sm: 'column' }}>
      <Box p={{ sm: '450' }}>
        <Text size="300" family="graphik" color="grey.1000" weight="600">
          <Trans>MWR History</Trans>
        </Text>
      </Box>
      <MWRHistoryContentStyled>
        <Stepper items={items}></Stepper>
      </MWRHistoryContentStyled>
    </Box>
  );
};
